import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/naming-convention */ import { Typography } from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Breadcrumb } from 'components/atoms/breadcrumb';
import { Sticky } from 'components/molecules/sticky';
import { Text02 } from 'components/styles';
import { queueMacrotask } from 'utils/macrotask';
const { Paragraph } = Typography;
const TitleComponent = styled.h4.attrs({
    'data-cy': 'page.header.title'
})`
  margin: 0;
  height: var(--height-lg);
  :root[data-new-theme-enabled='true'] & {
    height: 32px;
    line-height: 32px;
  }
`;
const Icon = styled.span.attrs({
    'data-cy': 'page.header.title.icon'
})``;
const Text = styled.span.attrs({
    'data-cy': 'page.header.title.text'
})``;
const SubText = styled(Paragraph).attrs({
    'data-cy': 'page.header.title.subtext'
})``;
const Title = TitleComponent;
Title.Icon = Icon;
Title.Text = Text;
const Tabs = styled.div``;
export const Captions = styled.div``;
const HeaderWrapper = styled.div`
  margin: 0;
  padding: 0;

  ${Captions} {
    display: flex;
    padding-bottom: var(--spacing-01);
    transition: padding var(--animation-duration-medium) ease;
  }

  ${Breadcrumb} {
    + ${Captions} {
      padding-top: 0;
    }
  }

  ${Title} {
    display: inline-flex;
    align-items: center;
    font-size: var(--heading-5-size);
    transition: transform var(--animation-duration-medium) ease;
    transform: scale(1);
    transform-origin: 0;
  }

  ${Title} > ${Icon} {
    margin-right: ${({ isBigIcon })=>isBigIcon ? 'var(--layout-01)' : 'var(--spacing-03)'};
    display: flex;
  }

  ${SubText} {
    ${Text02};

    color: var(--gray-80);
    /* padding-left: var(--layout-01); */
    margin-bottom: 0px;
  }
  &[data-has-tabs='true'] {
    padding-bottom: 0 !important;
  }
`;
const HeaderComponent = ({ sticky, title, tabs, breadcrumbs, subText, ...props })=>{
    const [scrolled, setScrolled] = useState(false);
    const isCompact = true;
    useEffect(()=>{
        if (!scrolled && isCompact) {
            queueMacrotask(()=>setScrolled(true));
        }
    }, [
        scrolled,
        setScrolled,
        isCompact
    ]);
    return sticky ? /*#__PURE__*/ _jsx(Sticky, {
        top: 0,
        layer: 9,
        children: /*#__PURE__*/ _jsxs(HeaderWrapper, {
            id: "page_header",
            "data-cy": "page_header",
            compact: isCompact,
            "data-has-tabs": !!tabs,
            ...props,
            children: [
                breadcrumbs && /*#__PURE__*/ _jsx(Breadcrumb, {
                    children: breadcrumbs
                }),
                /*#__PURE__*/ _jsx(Captions, {
                    children: title
                }),
                subText && /*#__PURE__*/ _jsx(SubText, {
                    children: subText
                }),
                tabs
            ]
        })
    }) : /*#__PURE__*/ _jsxs(HeaderWrapper, {
        id: "page_header",
        "data-cy": "page_header",
        "data-has-tabs": !!tabs,
        compact: true,
        ...props,
        children: [
            breadcrumbs && /*#__PURE__*/ _jsx(Breadcrumb, {
                children: breadcrumbs
            }),
            /*#__PURE__*/ _jsx(Captions, {
                children: title
            }),
            subText && /*#__PURE__*/ _jsx(SubText, {
                children: subText
            }),
            tabs
        ]
    });
};
const StyledHeader = styled(HeaderComponent)`
  background: ${'var(--white-100)'};
`;
const Header = StyledHeader;
Header.Title = Title;
Header.Tabs = Tabs;
export { Header };
